import axios from "axios";
import AxiosProvider from "../../../AxiosProvider";
import AxiosProvider2 from "../../../AxiosProvider2";
import { applicationId } from "../../../config";
import * as actionType from "../cart/actionType";

export const orderCreationSuccess = () => ({
  type: actionType.ORDER_CREATION_SUCCESS,
});

export const create_order = (data, token, dispatch) => {
  const cart = JSON.parse(localStorage.getItem("cart"));
  const branchId = cart[0].branchId;
  const paymentMethod = "checkout";
  const products = cart;
  const platform = "android-pos";
  const typeId = localStorage.getItem("typeId");
  const tableId = localStorage.getItem("tableId");

  var body = {
    token: data.token,

    paymentMethod: paymentMethod,
    code: data.code,
    notes: "now",
    date: " ",
    now: "true",
    time: "",
    branchId: branchId,
    typeId: typeId,
    products: products,
    platform: platform,
  };

  // Only include tableId for dine-in orders (typeId === "5") and when tableId exists
  if (typeId === "5" && tableId) {
    body.tableId = tableId;
  }

  // Check if user is guest by checking localStorage directly (more reliable)
  const localToken = localStorage.getItem("TOKEN");
  let parsedLocalToken;
  try {
    parsedLocalToken = localToken ? JSON.parse(localToken) : null;
  } catch (e) {
    parsedLocalToken = localToken; // If parsing fails, use raw value
  }
  
  const isGuest = parsedLocalToken === "token" || parsedLocalToken === null || parsedLocalToken === undefined || 
                  token === "token" || token === null || token === undefined;
  
  // Build headers - only include Authorization for signed-in users
  const headers = {
    Accept: "application/json",
  };
  
  // Only add Authorization header if user is signed in (not a guest)
  if (!isGuest && token && token !== "token") {
    headers.Authorization = `Bearer ${token}`;
  }

  return AxiosProvider.post(`/orders`, body, {
    headers: headers,
    params: {
      applicationId: applicationId,
    },
  }).then((res) => {
    dispatch(orderCreationSuccess());
    return res;
  });
};

export const payment = (id, token) => {
  return AxiosProvider.get("/orders/tap/payment-status/" + id, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};
export const pay_again = (orderId, token) => {
  return AxiosProvider.get("orders/" + orderId + "/payment-url", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const invoiceData = (id, code, sk) => {
  const token = JSON.parse(localStorage.getItem("TOKEN"));

  let config = {};

  if (sk) {
    config = {
      params: { sk },
      headers: { Accept: "application/json" }
    };
  } else {
    config = {
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json"
      }
    };
  }

  return AxiosProvider2.get(`/orders/invoice/${id}`, config);
};

export const make_accept = (token, orderId, data) => {
  return AxiosProvider2.put(
    `/orders/${orderId}/make-accepted`,
    data,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        countryId: "SAR",
      },
    }
  );
};

export const checkPayment = (token, sessionId, currency) => {
  return AxiosProvider.get(
    `/orders/checkout/get-paymentlink-details?paymentLinkId=${sessionId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        countryId: currency == "SAR" ? 1 : 2,
      },
      params: {
        type: "order",
        platform: "qr",
        currency: currency,
      },
    }
  );
};
